import { render } from "./meal.vue?vue&type=template&id=41dbffa3&scoped=true"
import script from "./meal.vue?vue&type=script&lang=js"
export * from "./meal.vue?vue&type=script&lang=js"

import "./meal.vue?vue&type=style&index=0&id=41dbffa3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41dbffa3"]])

export default __exports__